import React, { useContext } from 'react';
import { RegistrationContext } from '../../../../contexts';
import { RegistrationActions } from '../../../../contexts/RegistrationContext/RegistrationReducer';
import { Button } from '../../../../components';
import { RegisterSections, REGISTER_PATH } from '../tools/constants';
import { useParams, useHistory } from 'react-router-dom';
import { getBackLink } from '../tools/helpers';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../../../styles/main.module.scss';

const { RESET_REGISTRATION_STATE } = RegistrationActions;

const cx = classNames.bind(styles);

const RegisterNavigation = ({
  nextAction,
  nextDisabled,
  resetRegistration,
  nextLabel,
  backAction,
  skipAction,
  nextButtonAttrs,
}) => {
  const [registerState, registerDispatch] = useContext(RegistrationContext);

  const history = useHistory();
  const { location } = history || {};
  const params = useParams();

  const { leagueId } = params || {};
  const { search } = location || {};
  const { step, league } = registerState || {};

  return (
    <div className="mb-4 d-flex justify-content-center align-items-center">
      <Button
        className={cx('secondary-btn', 'px-5 py-3 mr-2')}
        onClick={() => {
          if (resetRegistration) {
            registerDispatch({
              type: RESET_REGISTRATION_STATE,
            });
            history.push(`${REGISTER_PATH}/${leagueId}/${RegisterSections.REGISTRATION_TYPE.path}`);
            return;
          }
          if (backAction) {
            backAction();
            return;
          }

          history.push(getBackLink({ leagueId, search, league, step }));
        }}
      >
        Back
      </Button>
      <Button
        className={cx('primary-btn', 'px-5 py-3 ml-2')}
        disabled={!nextAction || nextDisabled}
        onClick={nextAction}
        attrs={nextButtonAttrs}
      >
        {nextLabel}
      </Button>
      {skipAction && (
        <Button className={cx('secondary-btn', 'px-5 py-3 ml-2')} onClick={skipAction}>
          Skip
        </Button>
      )}
    </div>
  );
};

RegisterNavigation.propTypes = {
  nextDisabled: PropTypes.bool,
  nextAction: PropTypes.func,
  resetRegistration: PropTypes.bool,
  nextLabel: PropTypes.string,
  backAction: PropTypes.func,
  skipAction: PropTypes.func,
  nextButtonAttrs: PropTypes.objectOf(PropTypes.string),
};

RegisterNavigation.defaultProps = {
  nextAction: undefined,
  backAction: undefined,
  skipAction: undefined,
  nextDisabled: true,
  resetRegistration: false,
  nextLabel: 'Next',
  nextButtonAttrs: {},
};

export default RegisterNavigation;
